
interface Property {
  id: string;
  title: string;
  shortName?: string;
}

interface PropertyLabelsColumnProps {
  properties: Property[];
  rowHeight: number;
  labelColumnWidth: number;
}

const PropertyLabelsColumn = ({ properties, rowHeight, labelColumnWidth }: PropertyLabelsColumnProps) => {
  console.log('🔧 PropertyLabelsColumn render:', { 
    propertiesCount: properties.length, 
    rowHeight, 
    labelColumnWidth 
  });

  return (
    <div 
      style={{ 
        width: labelColumnWidth,
        minWidth: labelColumnWidth,
        maxWidth: labelColumnWidth
      }} 
      className="border-r bg-gray-50/50 sticky left-0 z-10"
    >
      {properties.map((property, index) => (
        <div
          key={property.id}
          className="flex items-center px-3 border-b bg-gray-50/50"
          style={{ 
            height: rowHeight,
            minHeight: rowHeight,
            maxHeight: rowHeight
          }}
        >
          <div className="truncate w-full">
            <p className="font-medium text-sm text-gray-900" title={property.title}>
              {property.shortName || property.title}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PropertyLabelsColumn;
